import store from "../../redux/store";

function GetUnderkontoNames() {
  var state = store.getState();
  if (
    !state ||
    !state.user.user ||
    !state.user.user.id ||
    !state.user.user.underkontonamns
  )
    return null;
  return state.user.user.underkontonamns;
}

store.subscribe(GetUnderkontoNames);

export default GetUnderkontoNames;
